import { render, staticRenderFns } from "./RemovableCard.vue?vue&type=template&id=2a9c1f87&scoped=true&"
import script from "./RemovableCard.vue?vue&type=script&lang=js&"
export * from "./RemovableCard.vue?vue&type=script&lang=js&"
import style0 from "./RemovableCard.vue?vue&type=style&index=0&id=2a9c1f87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9c1f87",
  null
  
)

export default component.exports